import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar-thin",
  "use": "calendar-thin-usage",
  "viewBox": "0 0 24 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 26\" id=\"calendar-thin\"><g fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(1 1)\"><rect width=\"22\" height=\"21.6\" y=\"2.4\" rx=\"2\" /><path d=\"M15.889 0v4.8M6.111 0v4.8M0 9.6h22\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol